import { IState } from './sm.types';
import { EnrolledGroupCTAButtonTypes } from '@constants/individualPortal/customGrouping/customGrouping.constants';

const states: IState = {
    //Enrolled Members CTA states
    enrolledMemberCta: {
        transitions: [
            'allIneligibileMembers',
            'insideOEPEnrollmentWindow',
            'outsideOEP_SEPApplication',
            'outsideOEP_QEorOEApplication',
        ],
    },
    insideOEPWindow: {
        transitions: ['insideOEP_SEPapplication', 'insideOEP_QEPapplication', 'insideOEP_OEapplication'],
    },
    outsideOEP_SEP: {
        transitions: [
            'outsideOEP_SEPenrollementNotSimiarToPriorApplicationId',
            'outsideOEP_SEPAllowToChangePlan',
            'groupAllowedToChangePlan',
            'isBlank',
        ],
    },
    outisdeOEP_QEPorOE: {
        transitions: ['allowedToChangePlan', 'notAIANMemberOrLowFPL', 'enrollmentCoverageDateInThisMonth'],
    },
    insideOEP_SEP: {
        transitions: ['enrollmentIdSimilartoPriorApplicationId', 'enrollmentIdNotEqualtoPriorApplicationId'],
    },
    insideOEP_OE: {
        transitions: ['groundRenewal', 'nonGroupRenewal'],
    },
    newApplication: {
        transitions: ['unenrolledDentalMembers', 'allEnrolledDentalMembers'],
    },
    isFinalizeEnrollment: {
        onEnter(sm) {
            sm.stop({
                btnText: 'customGrouping.finalizeEnrollment',
                type: EnrolledGroupCTAButtonTypes.IS_FINALIZE_ENROLLMENT,
            });
        },
    },
    isFinalizePlan: {
        onEnter(sm) {
            sm.stop({
                btnText: 'customGrouping.finalizePlan',
                type: EnrolledGroupCTAButtonTypes.IS_FINALIZE_PLAN,
            });
        },
    },
    isRenewOrChangePlan: {
        onEnter(sm) {
            sm.stop({
                btnText: 'customGrouping.renewOrChangePlan',
                type: EnrolledGroupCTAButtonTypes.IS_RENEW_OR_CHANGE_PLAN,
            });
        },
    },
    isChangePlan: {
        onEnter(sm) {
            sm.stop({
                btnText: 'customGrouping.changePlan',
                type: EnrolledGroupCTAButtonTypes.IS_CHANGE_PLAN,
            });
        },
    },
    isBlank: {
        onEnter(sm) {
            sm.stop({
                btnText: '',
                type: EnrolledGroupCTAButtonTypes.IS_BLANK,
            });
        },
    },
};

export default states;
